"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.materialTheme = exports.FONTS = exports.COLORS = void 0;
// @ts-ignore
const Eina02_SemiBold_ttf_1 = __importDefault(require("../fonts/Eina02-SemiBold.ttf"));
// @ts-ignore
const Eina02_Regular_ttf_1 = __importDefault(require("../fonts/Eina02-Regular.ttf"));
// @ts-ignore
const Eina02_Bold_ttf_1 = __importDefault(require("../fonts/Eina02-Bold.ttf"));
const createTheme_1 = __importDefault(require("@material-ui/core/styles/createTheme"));
exports.COLORS = {
    green: "#47D06F",
    textBackground: "#E6E9EC40",
    red: "#FD3246",
    blue: "#007dff",
    white: "#FFFFFF",
    greyLight: "#FAFBFB",
    black30: "#001E3C4D",
    black40: "#001E3C66",
    black: "#001e3c",
    background: "#FCFCFC",
    border: "#E6E9EC",
};
const fontFaces = [
    {
        fontDisplay: "swap",
        fontFamily: "Eina02-SemiBold",
        src: `
      local('Eina02'),
      local('Eina02-SemiBold'),
      url(${Eina02_SemiBold_ttf_1.default})
    `,
    },
    {
        fontDisplay: "swap",
        fontFamily: "Eina02-Regular",
        src: `
        local('Eina02'),
        local('Eina02-Regular'),
        url(${Eina02_Regular_ttf_1.default})
      `,
    },
    {
        fontDisplay: "swap",
        fontFamily: "Eina02-Bold",
        src: `
        local('Eina02'),
        local('Eina02-Bold'),
        url(${Eina02_Bold_ttf_1.default})
      `,
    },
];
exports.FONTS = {
    semiBold: "Eina02-SemiBold",
    regular: "Eina02-Regular",
    bold: "Eina02-Bold",
    light: "Eina02-Light",
};
const materialTheme = createTheme_1.default({
    breakpoints: {
        values: {
            xs: 0,
            sm: 700,
            md: 1000,
            lg: 1500,
            xl: 2000,
        },
    },
    typography: {
        fontFamily: exports.FONTS.regular,
        fontSize: 16,
        h1: {
            fontFamily: exports.FONTS.bold,
            fontSize: 48,
        },
        h2: {
            fontFamily: exports.FONTS.bold,
            fontSize: 24,
        },
        subtitle1: {
            fontFamily: exports.FONTS.semiBold,
            fontSize: 18,
        },
        subtitle2: {
            fontFamily: exports.FONTS.regular,
            fontSize: 18,
        },
        body1: {
            fontFamily: exports.FONTS.semiBold,
            fontSize: 14,
        },
        body2: {
            fontFamily: exports.FONTS.regular,
            fontSize: 14,
        },
        caption: {
            fontFamily: exports.FONTS.regular,
            fontSize: 16,
            color: exports.COLORS.black40,
        },
    },
    palette: {
        primary: {
            main: exports.COLORS.red,
        },
        secondary: {
            main: exports.COLORS.blue,
        },
        background: {
            default: exports.COLORS.background,
            paper: exports.COLORS.border,
        },
        success: {
            main: exports.COLORS.green,
        },
        common: {
            black: exports.COLORS.black,
            white: exports.COLORS.white,
        },
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                "@font-face": fontFaces,
                body: {
                    backgroundColor: "none",
                },
                input: {
                    outline: "none",
                },
                a: {
                    textDecoration: "none",
                },
                textarea: { outline: "none" },
                ul: {
                    listStyle: "none",
                    margin: 0,
                    padding: 0,
                },
            },
        },
        MuiChip: {
            root: {
                borderRadius: 4,
            },
            sizeSmall: {
                fontSize: 10,
            },
        },
        MuiTypography: {
            paragraph: { marginBottom: 10 },
        },
        MuiDialog: {
            paper: { background: "white" },
        },
        MuiBackdrop: {
            root: {
                backgroundColor: `${exports.COLORS.black30}`,
            },
        },
        MuiButton: {
            root: {
                fontSize: 14,
                fontFamily: exports.FONTS.semiBold,
                textTransform: "inherit",
                boxShadow: "none",
                height: 48,
                whiteSpace: "nowrap",
                minWidth: 183,
            },
            text: {
                background: exports.COLORS.greyLight,
            },
            sizeSmall: { fontSize: 10, height: 24, minWidth: 80 },
            contained: { "&:hover": { boxShadow: "none" } },
            containedPrimary: {
                boxShadow: "none",
                "&$disabled": {
                    color: "white",
                    backgroundColor: exports.COLORS.red,
                    opacity: 0.2,
                },
            },
            containedSecondary: {
                boxShadow: "none",
                "&$disabled": {
                    color: "white",
                    backgroundColor: exports.COLORS.blue,
                    opacity: 0.2,
                },
            },
            outlinedPrimary: {
                "&$disabled": {
                    color: exports.COLORS.red,
                    borderColor: exports.COLORS.red,
                    opacity: 0.2,
                },
            },
            outlinedSecondary: {
                "&$disabled": {
                    color: exports.COLORS.blue,
                    borderColor: exports.COLORS.blue,
                    opacity: 0.2,
                },
            },
        },
        MuiTabs: {
            indicator: { display: "none" },
        },
        MuiCard: {
            root: { background: "white" },
        },
        MuiCircularProgress: {
            colorPrimary: { color: exports.COLORS.red },
            colorSecondary: { color: exports.COLORS.blue },
            root: {
                color: exports.COLORS.white,
            },
        },
    },
});
exports.materialTheme = materialTheme;
materialTheme.typography.h1 = {
    fontFamily: exports.FONTS.bold,
    fontSize: 48,
    whiteSpace: "nowrap",
    [materialTheme.breakpoints.down("xs")]: {
        fontSize: 36,
        fontFamily: exports.FONTS.bold,
    },
};
materialTheme.typography.subtitle2 = {
    fontSize: 18,
    fontFamily: exports.FONTS.regular,
    [materialTheme.breakpoints.down("xs")]: {
        fontSize: 14,
        fontFamily: exports.FONTS.regular,
    },
};
materialTheme.typography.subtitle1 = {
    fontSize: 18,
    fontFamily: exports.FONTS.semiBold,
    "&$paragraph": { marginBottom: 8 },
    [materialTheme.breakpoints.down("xs")]: {
        fontSize: 14,
    },
};
//# sourceMappingURL=material-ui-theme.js.map